var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"阶段标准"}},[_c('AdetectUvSuggest')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"多年增长标准值"}},[_c('UvAllForm',{attrs:{"num":_vm.num}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }